import { useRemoteStrings } from '@acorns/web-utils'
import React from 'react'

import { useProgramAgreementQuery } from 'generated/types'

import { Text } from './styled-components'

export const ProgramAgreement = () => {
  const { StyledRemoteString } = useRemoteStrings()
  const { data, loading } = useProgramAgreementQuery()

  if (loading) {
    return null
  }

  return (
    <Text>
      <StyledRemoteString
        stringKey={'product_onboarding.welcome.program_agreement.footnote.variable'}
        variables={['NEXT', data.acceptanceDocument.url]}
      />
    </Text>
  )
}
